import{jsx as r,jsxs as e}from"react/jsx-runtime";import{isValidElement as a}from"react";import d from"tailwind-styled-components";import o from"clsx";import{XOctagon as t,Info as l,CheckCircle as i,AlertTriangle as n}from"lucide-react";import s from"../paragraph/paragraph.js";const m=d.div`
  bg-white
  border
  border-gray-100
  border-l-4
  mb-4
  p-4
  rounded
  shadow-md
  flex
  items-center

  dark:bg-gray-700
  dark:border-gray-800
  dark:text-gray-300
`,c=d.h2`
  text-lg
  font-bold
`,b=d.div``,g=({children:d,className:g,iconSize:p=36,title:h,type:x="info",...y})=>{const w=o(g,{"border-l-red-500 dark:border-l-red-500 shadow-red-500/10":"error"===x,"border-l-brand-primary dark:border-l-brand-primary-light shadow-brand-primary/10":"info"===x,"border-l-green-500 dark:border-l-green-500 shadow-green-500/10":"success"===x,"border-l-yellow-500 dark:border-l-yellow-500 shadow-yellow-500/10":"warning"===x}),f=o("mr-4 text-3xl leading-none",{"text-red-500 dark:text-red-500":"error"===x,"text-brand-primary dark:text-brand-primary-light":"info"===x,"text-green-500 dark:text-green-500":"success"===x,"text-yellow-500 dark:text-yellow-500":"warning"===x}),k=a(d)?d:r(s,{children:d});return e(m,{className:w,role:"alert",...y,children:["error"===x&&r(t,{className:f,size:p}),"info"===x&&r(l,{className:f,size:p}),"success"===x&&r(i,{className:f,size:p}),"warning"===x&&r(n,{className:f,size:p}),e(b,{children:[h&&r(c,{children:h}),k]})]})};export{g as Alert,g as default};
